var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-container",attrs:{"id":"join-test-main"}},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn-md btn-primary col-3",on:{"click":_vm.moveLgn}},[_vm._v("login-test")]),_c('button',{staticClass:"btn btn-md btn-gray col-3",on:{"click":_vm.moveTrans}},[_vm._v("trans-test")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }